import slugify from 'slugify'

export default function slugMe(string) {
  return slugify(string, { lower: true, remove: /[*+~.&()'"!:@?\\/]/g })
}
